import React from 'react';
import SvgIcon from '../../SvgIconWrapper';

interface ZoomExtentIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number | string;
}

const ZoomExtentIcon: React.FC<ZoomExtentIconProps> = ({ strokeWidth = 2, ...props }) => (
  <SvgIcon {...props} viewBox="0 0 24 24" className="sx-icon-zoom-extent">
    <path
      d="M15 9L21 3M21 3H15M21 3V9M9 9L3 3M3 3L3 9M3 3L9 3M9 15L3 21M3 21H9M3 21L3 15M15 15L21 21M21 21V15M21 21H15"
      fill="none"
      stroke={props.color || 'currentColor'}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export default ZoomExtentIcon;
